import {addReceptionUrl, getCompanyDataUrl, getCustomerDataUrl, getReceptionUrl, getVisitsUrl} from "../api";
import {customAxios as axios, getToken} from "../../../request";
import {hideLoader, showLoader} from "../../../actions/loader";
import {notification} from "../../../components/Elements/appUtils";
import { singleUserUrl, updateUserUrl } from "../api";
export const fetchCompany = async (valData) => {
    let config = {
        params: {...valData}
    }
    const {data} = await axios.get(getCompanyDataUrl(), config);
    return data;
};

export const fetchCustomer = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getCustomerDataUrl(), config);
    return data;
};

export const fetchReception = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getReceptionUrl(), config);
    return data;
};

export const fetchVisits = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    }
    const {data} = await axios.get(getVisitsUrl(), config);
    return data;
};

export const addReceptionFxn = (valData) => async (dispatch) => {
    dispatch(showLoader())
    const {data} = await axios.post(addReceptionUrl(), valData, getToken());
    console.log(data,"this is data in doctor function");
    dispatch(hideLoader())
    if (!data.error) {
        notification.success({message: data.message || "Success"})
    } else {
        notification.error({message: data.message || "Error"})
    }
    return data;
};
export const singleUserFxn = (id) => async (dispatch) => {
    dispatch(showLoader());
    
    let { data } = await axios.get(singleUserUrl(id));
    console.log(data);
    dispatch(hideLoader());
    if (data.error) {
      notification.error({
        message: data.message || "Error",
      });
    }
  
    return data;
  };
  export const updateUserFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(updateUserUrl(), valData ,getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
  };